import { notFound, redirect } from '@tanstack/react-router';
import { KIND_SLUGS, slugOfKindName, type KindSlug } from './kinds';

const isSlug = (value: string): value is KindSlug => (KIND_SLUGS as readonly string[]).includes(value);

/**
 * The review page's `$kind` parser (routes/_authed/review/$kind.tsx `params.parse`). A stage's own address
 * ("prices") is itself. The kind's own name ("/review/influencer") is that stage under another spelling: it redirects
 * there, keeping the search, so a seat without the stage reads its role refusal.
 * Anything else is not found.
 */
export function parseKindParam({ kind }: { kind: string }): { kind: KindSlug } {
  if (isSlug(kind)) return { kind };
  const slug = slugOfKindName(kind);
  if (slug) throw redirect({ to: '/review/$kind', params: { kind: slug }, search: true, replace: true });
  throw notFound();
}
